import {ScoresListHeaderModuleController} from "../scores-list-header-module.controller";
import {BaseLinkModel} from "../../../infrastructure/models/link/base-link-model";
import {BaseModuleProps} from "../../../infrastructure/models/props/base-module-props";

export class ScoresListHeaderModuleProps extends BaseModuleProps {
  controller: ScoresListHeaderModuleController;
  liveGamesCount: Number;
  linkType: BaseLinkModel;
  date: Date;
  isLive: Boolean;
  toRenderCalendar: Boolean;
  toRenderLiveSwitch: Boolean;
  switchOnClick: Function;
  nextTooltip: String;
  prevTooltip: String;
  nextLinkModel: BaseLinkModel;
  previousLinkModel: BaseLinkModel;
  onClickPrevious: Function;
  onClickNext: Function;
  onDateChange: Function;
}
